import React from 'react';
import Panel from './Panel';
import InclusaoAssociado from '../../components/Panel/RegisterCompany/InclusaoAssociado';

const InclusaoAssociadoPage = () => {

  return (
    <Panel>
      <div>
        <InclusaoAssociado />
      </div>
    </Panel>

  );
};

export default InclusaoAssociadoPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/InclusaoAssociadoPage.js
 **/